import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { reducer } from '.';
import { EffectsModule } from '@ngrx/effects';
import { AdvanceSettingEffects } from './reports/adavance-settings/advance-setting.effects';
import { AiAnalyticsEffects } from './ai-analytics/ai-analytics.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forRoot(reducer),
    EffectsModule.forRoot([AdvanceSettingEffects, AiAnalyticsEffects]),
    StoreDevtoolsModule.instrument({ maxAge: 10 }),
  ],
  declarations: [],
})
export class StateModule {}
